import TrackedItemsPerformance from "@/components/trackedItemsPerformance/trackedItemsPerformance.vue";
import TrackedItemsTable from "@/components/trackedItemsTable/trackedItemsTable.vue";

export default {
	components: {
		TrackedItemsPerformance,
		TrackedItemsTable,
	},

	data() {
		return {
			// eslint-disable-next-line line-comment-position, no-inline-comments
			dataStatus: [false, false],
		};
	},

	computed: { readyToPrint },

	methods: {
		notifyLoaded,
		printPage,
	},
};

function notifyLoaded(num) {
	this.dataStatus[num] = true;
	// remind Vue to track the change...
	this.dataStatus = { ...this.dataStatus };
}

function printPage() {
	this.$utils.printPage(this);
}

function readyToPrint() {
	return Object.values(this.dataStatus).every(Boolean);
}
